export default __webpack_public_path__ + "static/media/shop-slide-03.f45cb342.jpg";